import { h, Component } from 'preact';
import Store from 'store/store';
import { Howl, Howler } from 'howler';

export default class Sound extends Component {
	constructor(props) {
		super(props);
		this.documentHidden = false;

		this.onPlayMusic = this.onPlayMusic.bind(this);
		this.onPlaySound = this.onPlaySound.bind(this);
		this.onResumeMusic = this.onResumeMusic.bind(this);
		this.onPauseMusic = this.onPauseMusic.bind(this);
		this.onVisibilityChange = this.onVisibilityChange.bind(this);
	}

	componentDidMount() {
		const { audioRoot } = this.props;

		this.state = {
			currentMusic: null
		};

		this.constructionPipe = new Howl({
			src: [`${audioRoot}/mvtc3f.mp3`],
			loop: false
		});

		this.pipe = new Howl({
			src: [`${audioRoot}/mbcstk.mp3`],
			loop: false
		});

		this.lostAndFoundSecret = new Howl({
			src: [`${audioRoot}/gr4uy6.mp3`],
			loop: false
		});

		this.robNotification = new Howl({
			src: [`${audioRoot}/f3sldm.mp3`],
			loop: false
		});

		this.robToggle = new Howl({
			src: [`${audioRoot}/lp0x7x.mp3`],
		});

		this.toggleSidebar = new Howl({
			src: [`${audioRoot}/w9j7pc.mp3`],
			loop: false
		});

		this.launchStar = new Howl({
			src: [`${audioRoot}/iewjnh.mp3`],
			loop: false,
			onload: () => {
				Store.emit('KEY_ASSET_LOADED', 'launchStarSound');
			}
		});

		this.starTrail0 = new Howl({
			src: [`${audioRoot}/cd7xza.mp3`],
			loop: false
		});

		this.starTrail1 = new Howl({
			src: [`${audioRoot}/mgz1sq.mp3`],
			loop: false
		});

		this.starTrail2 = new Howl({
			src: [`${audioRoot}/yub4bs.mp3`],
			loop: false
		});
		this.starTrail3 = new Howl({
			src: [`${audioRoot}/ufzg5l.mp3`],
			loop: false
		});

		this.airport = new Howl({
			src: [`${audioRoot}/ja5nle.mp3`],
			loop: true,
			volume: 0.1
		});

		this.upWorld0 = new Howl({
			src: [`${audioRoot}/k1qpze.mp3`],
			loop: true,
			volume: 0.75
		});

		this.upWorld1 = new Howl({
			src: [`${audioRoot}/hpqhe8.mp3`],
			loop: true,
			volume: 0.75
		});

		this.upWorld3 = new Howl({
			src: [`${audioRoot}/an1ap3.mp3`],
			loop: true,
			volume: 0.75
		});

		this.upWorld4 = new Howl({
			src: [`${audioRoot}/ycn4yq.mp3`],
			loop: true,
			volume: 0.75
		});

		this.brick0 = new Howl({
			src: [`${audioRoot}/brick-0.mp3`],
			loop: false
		});

		this.brick1 = new Howl({
			src: [`${audioRoot}/brick-1.mp3`],
			loop: false
		});

		this.brick2 = new Howl({
			src: [`${audioRoot}/brick-2.mp3`],
			loop: false
		});

		this.downWorld = new Howl({
			src: [`${audioRoot}/ulk3fz.mp3`],
			loop: true,
			volume: 0.75
		});

		this.slotMachineLever = new Howl({
			src: [`${audioRoot}/lever.mp3`],
			loop: false
		});

		this.slotMachineSuperStar = new Howl({
			src: [`${audioRoot}/superstar.mp3`],
			loop: false
		});

		this.slotMachinePowerUpMushroom = new Howl({
			src: [`${audioRoot}/mushroom-grow.mp3`],
			loop: false
		});

		this.coin = new Howl({
			src: [`${audioRoot}/coin-win.mp3`],
			loop: false
		});

		this.slotMachineSuperBell = new Howl({
			src: [`${audioRoot}/super-bell.mp3`],
			loop: false
		});

		this.barrelRoll = new Howl({
			src: [`${audioRoot}/hv7zak.mp3`],
			loop: false
		});

		Store.on('PLAY_SOUND', this.onPlaySound);
		Store.on('PLAY_MUSIC', this.onPlayMusic);
		Store.on('PAUSE_MUSIC', this.onPauseMusic);
		Store.on('RESUME_MUSIC', this.onResumeMusic);
		document.addEventListener('visibilitychange', this.onVisibilityChange);

		this.fadeTimer = null;
	}


	componentDidUpdate(prevProps) {
		const { muted } = this.props;
		if (prevProps.muted !== muted) {
			Howler.mute(muted || this.documentHidden);
		}
	}

	componentWillUnmount() {
		Store.off('PLAY_SOUND', this.onPlaySound);
		Store.off('PLAY_MUSIC', this.onPlayMusic);
		Store.off('PAUSE_MUSIC', this.onPauseMusic);
		Store.off('RESUME_MUSIC', this.onResumeMusic);
		document.removeEventListener('visibilitychange', this.onVisibilityChange);
	}

	onVisibilityChange() {
		this.documentHidden = document.visibilityState == 'visible' ? false : true;
		Howler.mute(this.props.muted || this.documentHidden);
	}

	onPlaySound(sound) {
		this[sound].play();
	}

	onPlayMusic(music) {
		const { currentMusic } = this.state;
		if (this.fadeTimer) {
			window.clearTimeout(this.fadeTimer);
			this.fadeTimer = null;
			if (currentMusic) {
				this[currentMusic].pause();
				this.setState({ currentMusic: music });
			}
		}
		music = music == 'upWorld2' ? 'upWorld1' : music; //upworld1 same as upworld2

		if (currentMusic) {
			this[currentMusic].fade(0.75, 0, 1000);
			this.fadeTimer = setTimeout(() => {	
				window.clearTimeout(this.fadeTimer);
				this.fadeTimer = null;
				this[currentMusic].pause();
				this.setState({ currentMusic: music });
			
			}, 1000);
		} else {
			this.setState({ currentMusic: music });
		}

		this[music].play();
		this[music].fade(0, 0.75, 1000);
	}

	onResumeMusic() {
		const { currentMusic } = this.state;
		if (currentMusic) {
			!this[currentMusic].playing() && this[currentMusic].play();
			this[currentMusic].fade(0, 0.75, 100);
		}
	}

	onPauseMusic() {
		const { currentMusic } = this.state;
		if (currentMusic) {
			this[currentMusic].fade(0.75, 0, 100);
		}
	}

	render() {
		return <div />;
	}
}
